import React, { Fragment, useMemo } from 'react';
import AppTable from '../../../constants/AppTable';
import { LoadingSpinner } from '../../../constants/AppLoading';
import { Customer, CustomerEMI } from '../../../helpers/models/Models';
import { StatusBadge } from '../../../constants/AppBadge';
import { formatMoney } from '../../../helpers/DateFormat';

interface CustomerListViewProps {
    data: {
        results: CustomerEMI[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
}

const ConsumerEmiListView: React.FC<CustomerListViewProps> = ({ data, loading, error, setOnURL }) => {
    console.log(data)
    const columns = [
        { header: 'SN', width: 0, accessor: 'member_sn', sortable: false },
        { header: 'Name', accessor: 'mem_name', sortable: false },
        { header: 'Spouse name.', width: 20, accessor: 'spouse_name', sortable: false },
        { header: 'Total Emi', width: 10, accessor: 'total_emi', sortable: false},
        { header: 'Total Pay', width: 10, accessor: 'total_pay', sortable: false},
        { header: 'Remaining Amount', width: 10, accessor: 'remaining_amount', sortable: false },
        { header: 'Province', accessor: 'province_name', sortable: false },
        { header: 'District', accessor: 'district_name', sortable: false },
        { header: 'Address', accessor: 'add_eng', sortable: false },
        { header: 'Ward No.', accessor: 'ward_no', width: 0, sortable: false },
        { header: 'Phone No.', width: 10, accessor: 'phone_no', sortable: false },
        { header: 'DOB.', width: 10, accessor: 'dob', sortable: false },
        { header: 'Tole', width: 10, accessor: 'tole_name', sortable: false },
        { header: 'Father Name', width: 10, accessor: 'father_name', sortable: false },
        { header: 'Meter con. Date.', width: 10, accessor: 'meter_conn_date', sortable: false },
        { header: 'Tap No.', width: 10, accessor: 'tap_no', sortable: false },
        { header: 'Gender', width: 10, accessor: 'gender', sortable: false },
    ];

    const modifiedData = useMemo(() => {
        if (!data || !data.results) return [];
        return data.results.map((item: CustomerEMI) => ({
            member_sn: item.member_sn,
            mem_name: item.mem_name,
            spouse_name: item.spouse_name,
            total_emi: formatMoney(item.total_emi),
            remaining_amount: formatMoney(item.remaining_amount),
            total_pay: formatMoney(item.total_pay),
            add_eng: item.add_eng,
            ward_no: item.ward_no,
            phone_no: item.phone_no,
            dob: item.dob,
            district_name: item.district_name,
            province_name: item.province_name,
            tole_name: item.tole_name,
            father_name: item.father_name,
            meter_conn_date: item.meter_conn_date,
            tap_no: item.tap_no,
            gender: item.gender === 1 ? "Male" : item.gender === 2 ? "Female" : "Others",
        }));
    }, [data]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onNext={() => data?.next && setOnURL(data.next)}
                onPrev={() => data?.previous && setOnURL(data.previous)}
            />
        </Fragment>
    );
};

export default ConsumerEmiListView;
